module.exports = __webpack_public_path__ + "static/media/logo.8b3d0676.svg";